<template>
    <div class="row">
        <div class="col-md-11">
            <date-picker v-model="times" type="datetime"
                         format="YYYY-MM-DD HH:mm"
                         display-format="jYYYY-jMM-jDD HH:mm"
                         :timezone="false"
                         auto-submit
                         label="زمان ارتقا"
                         endTime></date-picker>
        </div>
    </div>
</template>

<script>
import {Bus} from "@/main";

export default {
    name: "UpgradeClock",
    data() {
        return {
            nowTime: '',
            times: {

            },
        }
    },
    methods: {
        getTimesForNow() {
            $.ajax({
                url: `${url}/setting/clock`,
                type: 'GET',
                fn: this.getTimesForNow,
                headers: {
                    "ACCEPT": "application/json",
                    "Authorization": Token
                },
                success: (data) => {
                    this.nowTime = data.data.time_stamp;
                }
            });
        }
    },
    watch: {
        times: {
            handler: function (val) {
                let timeStamp = Date.parse(val);
                const startTime = timeStamp / 1000;
                Bus.$emit('getTimes', startTime,this.$vnode.key)
            },
            deep: true
        }
    },
    mounted() {
        this.times = {}
    }
}
</script>

<style scoped>

</style>